import instance from './axiosInstance';

// Per-product Global Mute kill switch. The server derives the product context
// from the `mode` query param (set globally on the axios instance), so no
// context is sent in the request body.
const routerPrefix = 'notification-channel/ai-alert-global-mute';

export interface GlobalMutePayload {
  muteFrom: string;
  muteUntil: string;
}

export interface GlobalMuteRow {
  id: number;
  customerId: number;
  context: string;
  muteFrom: string;
  muteUntil: string;
  createdAt: string;
  updatedAt: string;
  createdBy: number;
  isActive: boolean;
}

// An optional `mode` overrides the axios default (derived from the current
// product), letting one page target another product's context, e.g. mute
// video (`ei`) and ad (`ai`) from the same place.
export const fetchGlobalMute = async (mode?: string) => {
  return instance.get(routerPrefix, mode ? { params: { mode } } : undefined);
};

export const upsertGlobalMute = async (payload: GlobalMutePayload, mode?: string) => {
  return instance.put(routerPrefix, payload, mode ? { params: { mode } } : undefined);
};

export const clearGlobalMute = async (mode?: string) => {
  return instance.delete(routerPrefix, mode ? { params: { mode } } : undefined);
};
